import { Box } from '@redbubble/design-system';
import styles from './ToastWrapper.module.scss';

export const ToastWrapper = ({ children }) => {
  return (
    <Box className={styles.toastWrapper} data-testid="toast">
      {children}
    </Box>
  );
};
